export default "__VITE_ASSET__CyWnrqw$__"